import React from 'react';
import { getPath } from '../../utils/getPath';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        top: 15,
        right: 15,
        width: 30,
        height: 30,
        border: 'none',
        borderRadius: 0,
        background: 'none',
        opacity: 0.3,
        transition: 'opacity 0.4s ease',

        '&:hover': {
            opacity: 0.7,
        },
        ' &:active': {
            transform: 'translateY(1px)',
        },
    },
    CloseIcon: {
        width: '100%',
        height: '100%',
    },
    title: {
        fontFamily: 'Lato-Light',
        fontSize: 32,
        lineHeight: '38px',
        textTransform: 'uppercase',
        marginBottom: 30,
        [theme.breakpoints.down('xs')]: {
            fontSize: 24,
            lineHeight: '30px',
        },
    },
}));

export const CloseBtn = ({ onClose }) => {
    const classes = useStyles();

    return (
        <button className={classes.root} onClick={onClose}>
            <img src={getPath('public/img/close.svg')} alt="" className={classes.CloseIcon} />
        </button>
    );
};

export const Title = props => {
    const classes = useStyles();
    return (
        <Typography className={classes.title} {...props}>
            {props.children}
        </Typography>
    );
};
